<template>
  <dialog-modal-fi
    ref="dialogModal"
    class="cad-details-dialog-fi"
    prevent-close-on-click-outside
    only-body-scrollable
  >
    <template #body>
      <iframe
        v-if="cadUrl"
        ref="cadFrame"
        :src="cadUrl"
        class="cad-details-dialog-fi__iframe"
        frameborder="0"
      />
    </template>

    <template #button>
      <icon-fi icon="close" />
    </template>
  </dialog-modal-fi>
</template>

<script>
import { DialogModalFi, IconFi } from 'atoms';

export default {
  name: 'CadDetailsDialogFi',
  components: {
    IconFi,
    DialogModalFi,
  },
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    cadUrl: {
      type: String,
      default: null,
    },
  },
  methods: {
    open() {
      this.$refs.dialogModal.open();
    },
  },
};
</script>

<style src="./cad-details-dialog-fi" />
